import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import "./styles/LoginPage.css";
import logo from "/assets/logo.svg";
import eyeOpen from "/assets/eyeopen.png";
import eyeClose from "/assets/eyeclose.png";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [passwordType, setPasswordType] = useState("password");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    // รีเซ็ต title เป็นค่าเริ่มต้น
    document.title = "ICE-Smart" // หรือชื่อแอพของคุณ
    
    // ล้าง sessionStorage เพื่อให้แน่ใจว่าไม่มีข้อมูลเก่าหลงเหลืออยู่
    sessionStorage.clear();
  }, []);

  const togglePasswordVisibility = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await axios.post(`${import.meta.env.VITE_API_URL}/login`, {
        email: email,
        password: password,
      });

      if (response.data.status === "ok") {
        setLoading(true); // Set loading to true

        const userData = response.data.user;
        delete userData.password;
        const userDataSubset = {
          id: userData.id,
          email: userData.email,
          name: userData.name,
          activated_on: userData.activated_on,
          admin: userData.admin,
          branch_names: userData.branch_names,
          token: response.data.token,
        };

        sessionStorage.setItem("userData", JSON.stringify(userDataSubset));

        const firstLogin = userData.activated_on;
        const adminValue = userData.admin;
        setTimeout(() => {
          if (firstLogin === null) {
            if (adminValue) {
              document.title += " - Admin"; 
              navigate("/main");
            } else {
              navigate("/login/firstlogin");
            }
          } else if (adminValue) {
            document.title += " - Admin"; 
            navigate("/main");
          } else {
            navigate("/branch");
          }
        }, 1000); // Reduced delay to 1 second
      } else {
        setError(response.data.message);
      }
    } catch (error) {
      setError("อีเมลหรือรหัสผ่านไม่ถูกต้อง");
      console.error("Login error:", error);
    }
  };

  const renderFloatLabelInput = (
    label,
    type,
    name,
    id,
    value,
    onChange,
    required = true,
    autoComplete = "off"
  ) => (
    <div className={`float-label-wrapper ${error ? "error" : ""}`}>
      <input
        type={type}
        id={id}
        name={name}
        value={value || ""}
        onChange={onChange}
        className="float-input"
        required={required}
        placeholder=" "
        autoComplete={autoComplete}
      />
      <label htmlFor={id} className="float-label">
        {label} {required && <span className="required-star"> *</span>}
      </label>
    </div>
  );

  return (
    <div className="background-image">
      <div className="container">
        <form className="login-form" onSubmit={handleLogin}>
          <div className="logo">
            <img src={logo} alt="Logo" style={{ marginRight: "8px" }} />
          </div>
          <h2>เข้าสู่ระบบ</h2>

          {renderFloatLabelInput(
            "อีเมล",
            "email",
            "email",
            "email",
            email,
            (e) => setEmail(e.target.value),
            true,
            "email"
          )}
          <div style={{ position: "relative" }}>
            {renderFloatLabelInput(
              "รหัสผ่าน",
              passwordType,
              "new-password",
              "password",
              password,
              (e) => setPassword(e.target.value),
              true,
              "new-password"
            )}
            <a
              type="button"
              className="toggle-password-button"
              onClick={togglePasswordVisibility}
            >
              {passwordType === "password" ? (
                <img src={eyeOpen} alt="แสดงรหัสผ่าน" />
              ) : (
                <img src={eyeClose} alt="ซ่อนรหัสผ่าน" />
              )}
            </a>
          </div>
          {error && (
            <div className="loginError">
              <p>{error}</p>
            </div>
          )}
          <Button
            variant="contained"
            type="submit"
            disabled={loading}
            fullWidth
            sx={{
              marginTop: 2,
              fontFamily: '"IBM Plex Sans Thai", sans-serif',
              boxShadow: "none", // Removes the shadow
              backgroundColor: "#1976d2", // Default background color
              ":hover": {
                backgroundColor: "#1565c0", // Custom hover background color
                boxShadow: "none", // Ensures no shadow on hover
              },
              "&.Mui-disabled": {
                backgroundColor: "#2762F8", // Background color when button is disabled
              },
            }}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "เข้าสู่ระบบ"
            )}
          </Button>

          <div className="forgot-password-link">
            <Link to="/forgotpassword">ลืมรหัสผ่าน</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
